module.exports = __webpack_public_path__ + "static/media/20ECE31.a25c617e.jpg";